module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Screwdriver-3c62b6b66ebd47869bdc54b639cce79d.svg";